import React, { useState } from "react";
import InputField from "../../components/CustomFields/InputField";
import Dropdown from "../../components/CustomFields/Dropdown";

const EducationDetails = ({ applicant, handleNestedChange, errors }) => {
  const [selectedBoard, setSelectedBoard] = useState({});

  const handleBoardChange = (index, value) => {
    setSelectedBoard((prevState) => ({
      ...prevState,
      [index]: value,
    }));
    handleNestedChange("educationDetails", index, "degree", value);
  };

  return (
    <section className="p-4">
      <h2 className="text-lg font-bold mb-4 text-center">Previous Education Details</h2>

      {applicant.educationDetails.map((education, index) => {
        const educationErrors = errors?.educationDetails?.[index] || {};

        return (
          <div key={index} className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
            {/* School Name */}
            <InputField
              id={`schoolName-${index}`}
              label="School Name *"
              value={education.schoolName}
              onChange={(e) =>
                handleNestedChange("educationDetails", index, "schoolName", e.target.value)
              }
              error={educationErrors.schoolName}
            />

            {/* Degree Select */}
            <Dropdown
              id={`degree-${index}`}
              label="Board *"
              value={education.degree}
              onChange={(e) => handleBoardChange(index, e.target.value)}
              options={["State Board", "Metric", "CBSE", "Alango Indian", "Others"]}
              defaultOption="Select Board"
              error={educationErrors.degree}
            />

            {/* Show InputField for 'Other' Board selection */}
            {selectedBoard[index] === "Others" && (
              <InputField
                id={`otherBoard-${index}`}
                label="Other Board Name *"
                value={education.otherBoard || ""}
                onChange={(e) =>
                  handleNestedChange("educationDetails", index, "otherBoard", e.target.value)
                }
                error={educationErrors.otherBoard}
              />
            )}
          </div>
        );
      })}
    </section>
  );
};

export default EducationDetails;
